import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  updateProfile,
  GoogleAuthProvider,
  signInWithPopup,
  sendPasswordResetEmail
} from 'firebase/auth';
import { auth } from './config';
import { createUserRecord, getUserData, getUserRole } from './database';

export const registerUser = async (email, password, name) => {
  const cred = await createUserWithEmailAndPassword(auth, email, password);
  await updateProfile(cred.user, { displayName: name });
  await createUserRecord(cred.user.uid, { name, email, phone: '', avatar: '' });
  return cred.user;
};

export const loginUser = async (email, password) => {
  const cred = await signInWithEmailAndPassword(auth, email, password);
  return cred.user;
};

export const loginWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  const cred = await signInWithPopup(auth, provider);
  const user = cred.user;
  const existing = await getUserData(user.uid);
  if (!existing) {
    await createUserRecord(user.uid, {
      name: user.displayName || '',
      email: user.email,
      phone: '',
      avatar: user.photoURL || ''
    });
  }
  return user;
};

export const logoutUser = () => signOut(auth);
export const resetPassword = (email) => sendPasswordResetEmail(auth, email);
export { getUserRole };
export const onAuthChange = (callback) => onAuthStateChanged(auth, callback);
